import * as api from './api'
import { USER_DATA } from '@/constants/localStorage'
import { THREE_HOUR } from '@/constants/time'

import { getLocalData, setLocalData } from '@/helper/localStorage'
import { checkTtlDate } from '@/helper'

export default {
  async loadData ({ commit, getters }) {
    const userDataLocal = getLocalData(USER_DATA)

    const isNeedUpdate = checkTtlDate({
      timeUpdate: (userDataLocal?.updateDate || 0),
      ttlTime: THREE_HOUR
    })

    if (userDataLocal && !isNeedUpdate) {
      commit('setData', userDataLocal.data)

      return { data: userDataLocal.data }
    }

    const { data } = await api.loadData(getters.getUserId) || {}

    if (data?.code === 200) {
      setLocalData(USER_DATA, {
        updateDate: Date.now(),
        data: data.data
      })
      commit('setData', data.data)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async auth ({ commit }, payload) {
    localStorage.clear()

    const { data } = await api.auth(payload) || {}

    if (data?.code === 200) {
      commit('setData', data.data)
      setLocalData(USER_DATA, {
        updateDate: Date.now(),
        data: data.data
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async logout ({ getters, dispatch }) {
    const { data } = await api.logout(getters.getUserId) || {}

    if (data?.code === 200) {
      localStorage.clear()
      dispatch('config/resetLocalStore', {}, { root: true })
    }

    return { error: data.data }
  },
  async change ({ commit, getters }, payload) {
    const { data } = await api.change(getters.getUserId, payload) || {}

    if (data?.code === 200) {
      commit('setData', data.data)

      setLocalData(USER_DATA, {
        updateDate: Date.now(),
        data: data.data
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async changePassword ({ getters }, payload) {
    const { data } = await api.changePassword(getters.getUserId, payload) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data.data }
  }
}